import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import styled from 'styled-components';
import { Text } from 'foundations-components/components/Text';
import { LayoutType } from 'signup-components/types';
import { useLayoutTemplate } from '../hooks/useLayoutTemplate';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledStepSubtitleContainer = styled.div.withConfig({
  displayName: "StepSubtitle__StyledStepSubtitleContainer"
})(({
  theme
}) => Object.assign({
  marginBottom: theme.space['400']
}, theme.embedded && {
  marginBottom: '0'
}));
export const StepSubtitle = ({
  message = '',
  children,
  messageOptions
}) => {
  const {
    layoutType
  } = useLayoutTemplate();
  if (message && isValidI18nKey(message)) {
    return (
      /*#__PURE__*/
      /* @bend-expect trellis-tokenized */
      _jsx(StyledStepSubtitleContainer, {
        children: /*#__PURE__*/_jsxs(Text, {
          as: "h3",
          textAlign: layoutType === LayoutType.SidePanel ? 'left' : 'center',
          typography: "body-500",
          children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: message,
            options: messageOptions
          }), children]
        })
      })
    );
  }
  return null;
};